<template>
    <div class="search-tab">
      <span class="install-tip">{{$t('T_ALERT_INPUT_INSTALLATION_CONDITION')}}</span>
      <el-row class="panel">
        <el-col :span="unitCol">
          <span class="text-title" :title="$t('T_SCALE')">{{ $t('T_SCALE') }}</span>
          <el-select v-model="unitData" class="unit-select">
            <el-option v-for="item in unitDataOptions" :key='item.value' :label='$t(item.value)' :value='item'>
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="throwDistanceCol">
          <span class="text-title" :title="$t('T_LENS_THROW_DISTANCE')">{{ $t('T_LENS_THROW_DISTANCE') }}</span>
          <span v-if="unitData.value === 'T_FEET_FRACTION' || unitData.value === 'T_INCH_FRACTION'">
            <FtInput v-model="throwDistance" :unitData="unitData.value"  @blur="formatInput('throwDistance')"></FtInput>
          </span>
          <span v-else>
            <el-input v-model="throwDistance" @input="testDigital($event, 'throwDistance')"  @blur="formatInput('throwDistance')" style="width: 60px"></el-input>
            <span class="text-title unit" :title="unitLabel">{{unitLabel}}</span>
          </span>
        </el-col>
        <el-col :span="screenSizeCol">
          <span class="text-title" :title="$t('T_SCREEN_SIZE')">{{ $t('T_SCREEN_SIZE') }}</span>
          <span v-if="(unitData.value === 'T_FEET_FRACTION' || unitData.value === 'T_INCH_FRACTION') && dwhSelect !== '0'">
            <FtInput v-model="screenSizeData" :unitData="unitData.value" @blur="formatInput('screenSizeData')"></FtInput>
          </span>
          <el-input v-model="screenSizeData" @input="testDigital($event, 'screenSizeData')"
            @blur="formatInput('screenSizeData')" style="width: 60px" v-else></el-input>
          <span class="text-title" v-if="dwhSelect !== '0' && !isFraction" :title="unitLabel">{{unitLabel}}</span>
          <span class="text-title" v-if="dwhSelect === '0'">{{ $t('T_INCH') }}</span>
          <el-select v-model="dwhSelect" @change='changeDehSelect' class="condition-select">
            <el-option v-for="item in dwhSelectOptions" :key='item.value' :label='$t(item.label)' :value='item.value'>
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="aspectRatioCol">
          <span class="text-title" :title="$t('T_ASPECT_RATIO')">{{ $t('T_ASPECT_RATIO') }}</span>
            <el-select v-model="aspectRatioData" clearable :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')" class="condition-select">
              <el-option v-for="item in aspectRatioOptions" :key='item.value' :label='item.label' :value='item.value'>
              </el-option>
            </el-select>
        </el-col>
      </el-row>
      <el-row class="panel" style="font-weight: bold;cursor: pointer" @click.native="down = !down">
        <span>{{ $t('T_SEARCH_OPTION') }}</span>
        <i class="el-collapse-item__arrow el-icon-arrow-right" :class="{'is-active': down}"></i>
      </el-row>
      <el-row class="panel" style="background: #f0f0f0" v-show="!down">
        <el-col :span="8" style="padding-left: 70px">
          <span class="text-title title-width">{{ $t('T_INFO_BRIGHTNESS') }}</span>
          <el-input v-model="brightnessMin" @input="testDigital($event, 'brightnessMin')" @blur="formatInput('brightnessMin')" style="width: 60px"></el-input>
          {{ $t('T_SEARCH_RANGE_TO') }}
          <el-input v-model="brightnessMax" @input="testDigital($event, 'brightnessMax')" @blur="formatInput('brightnessMax')" style="width: 60px"></el-input>
          lumen
        </el-col>
        <el-col :span="8" style="text-align: center">
          <span class="text-title">{{ $t('T_LENS_SHIFT') }}</span>
           <el-select v-model="lesShiftData" style="width: 152px" clearable :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')">
              <el-option v-for="item in lesShift" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="panel" style="background: #f0f0f0" v-show="!down">
        <el-col :span="8" style="padding-left: 70px">
          <span class="text-title title-width">{{ $t('T_AMBIENT') }}</span>
          <el-input v-model="ambientMin" @input="testDigital($event, 'ambientMin')" @blur="formatInput('ambientMin')" style="width: 60px"></el-input>
          {{ $t('T_SEARCH_RANGE_TO') }}
          <el-input v-model="ambientMax" @input="testDigital($event, 'ambientMax')" @blur="formatInput('ambientMax')" style="width: 60px"></el-input>
          lx
        </el-col>
        <el-col :span="8" style="text-align: center">
          <span class="text-title">{{ $t('T_ROOM_TYPE') }}</span>
          <el-select v-model='appSelect' style="width: 152px" clearable :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')">
            <el-option v-for='item in application' :key='item.value' :label='$t(item.label)' :value='item.value'>
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="panel btn-right">
        <el-button type="button" @click="searchAction">{{ $t('T_SEARCH') }}</el-button>
      </el-row>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { EventBus } from '@/common/event-bus.js'
import Vue from 'vue'
import FtInput from '@/components/ftInput'

export default {
  components: { FtInput },
  data () {
    return {
      options: [],
      value: '',
      input: '',
      down: true,
      unitData: {},
      dwhSelect: '',
      aspectRatioData: '',
      screenSizeData: '',
      screenSizeDataNow: '',
      appSelect: '',
      throwDistanceNow: '',
      throwDistance: '',
      brightnessMin: '',
      brightnessMax: '',
      throwRatioMin: '',
      throwRatioMax: '',
      lesShiftData: '',
      ambientMin: '',
      ambientMax: '',
      aspectRatioOptions: [{
        value: '16:10',
        label: '16:10'
      }, {
        value: '16:9',
        label: '16:9'
      }, {
        value: '4:3',
        label: '4:3'
      }],
      lesShift: [{
        value: '0',
        label: 'No'
      }, {
        value: '1',
        label: 'Yes'
      }],
      dwhSelectOptions: [
        {
          value: '0',
          label: 'T_DIAGONAL'
        }, {
          value: '1',
          label: 'T_WIDTH'
        }, {
          value: '2',
          label: 'T_HEIGHT'
        }
      ],
      application: [{
        value: '0',
        label: 'T_MEETING_ROOM'
      }, {
        value: '1',
        label: 'T_CLASS_ROOM'
      }, {
        value: '2',
        label: 'T_EVENT_HALL'
      }, {
        value: '3',
        label: 'T_LIVING_ROOM'
      }, {
        value: '4',
        label: 'T_THEATRE_ROOM'
      }],
      // 3, 5, 3, 3, 20   140 210 140 70 14
      applicationValue: [{
        limit: 3,
        bright: 140
      }, {
        limit: 5,
        bright: 210
      }, {
        limit: 3,
        bright: 140
      }, {
        limit: 3,
        bright: 70
      }, {
        limit: 20,
        bright: 14
      }]
    }
  },

  mounted () {
    // if (this.InitConfig.initMain === 1) {
    let temp = this.initConfig.initUnit === '' ? 'T_METRE_M' : this.initConfig.initUnit
    this.unitData = this.unitDataOptions.filter((item) => {
      return item.value === temp
    })[0]
    // } else {
    // this.unitData = this.unitDataOptions[0]
    // }
    this.aspectRatioData = this.aspectRatioOptions[0].value
    this.dwhSelect = this.dwhSelectOptions[0].value
  },

  computed: {
    ...mapState([
      'unitDataOptions',
      'selectedLensData',
      'searchTabActive',
      'installMatchingModelData'
    ]),

    initConfig () {
      return Vue.prototype.InitConfig
    },

    unitLabel () {
      return this.$t(this.unitData.value)
    },
    isFraction () {
      return this.unitData.value === 'T_FEET_FRACTION' || this.unitData.value === 'T_INCH_FRACTION'
    },
    currentLang () {
      return this.$i18n.locale
    },
    unitCol () {
      return 5
    },
    throwDistanceCol () {
      return 6
    },
    screenSizeCol () {
      return 8
    },
    aspectRatioCol () {
      return 5
    }
  },

  watch: {
    unitData (newValue, oldValue) {
      this.throwDistance = this.$commonJs.changeUnit(this.throwDistanceNow, this.unitData.value)
      this.changeDehSelect()
    },
    searchTabActive (val) {
      if (val === 'InstallCondition') {
        this.MATCHINGMODELDATA(this.installMatchingModelData)
      }
    }
  },

  methods: {
    searchAction () {
      let tempWidth = this.$commonJs.changeUnit(this.screenSizeData, this.unitData.value, true)
      let tempArray = this.aspectRatioData.split(':')
      let aspectRatioData = this.aspectRatioData
      let screenSizeDataNow = this.screenSizeDataNow
      // 对角线求宽度
      if (this.dwhSelect === '0') {
        let tempRatio = tempArray[0] / tempArray[1]
        tempWidth = this.$commonJs.changeUnit(this.screenSizeData, 'T_INCH_DECIMAL', true) * tempRatio / Math.sqrt(1 + Math.pow(tempRatio, 2))
      }
      // 高度求宽度
      if (this.dwhSelect === '2') {
        tempWidth = tempWidth * tempArray[0] / tempArray[1]
      }
      let temp = this.$commonJs.changeUnit(this.throwDistance, this.unitData.value, true) / tempWidth
      let tempResult = []
      let result = []
      this.ProjectorSpec.forEach((item) => {
        var { matchingLensID, selectedLensInfo } = this.$commonJs.findLensInfo(item)
        // let realThrowRatio = (selectedLensInfo.throwRatio || '').split('-')
        // matchingLensID 匹配的lens，用throw ratio进行比较
        let realThrowRatio = (selectedLensInfo.throwRatio || '').split('-')
        if (realThrowRatio.length > 1 && temp >= realThrowRatio[0].trim() && temp <= realThrowRatio[1].trim()) {
          if (this.filterProjector(item) && this.filterLensInfo(selectedLensInfo)) {
            tempResult.push(item)
          }
        } else if (realThrowRatio.length === 1 && temp === realThrowRatio[0].trim()) {
          if (this.filterProjector(item) && this.filterLensInfo(selectedLensInfo)) {
            tempResult.push(item)
          }
        } else {
          if (this.comparenLesThrowratio(matchingLensID, item.lcdSize, temp)) {
            if (this.filterProjector(item) && this.filterLensInfo(selectedLensInfo)) {
              tempResult.push(item)
            }
          }
        }
      })
      tempResult.forEach((item) => {
        let selectedLensInfo = this.$commonJs.findLensInfo(item).selectedLensInfo
        let distInfoTemp = selectedLensInfo.lcd.distInfo || ''
        let distInfo
        if (distInfoTemp.length >= 1) {
          distInfo = distInfoTemp.filter((info) => {
            return info.ratio === aspectRatioData
          })
        }
        if (distInfo.length >= 1) {
          let screenSizeMin = distInfo[0].screenSize.w.min
          let screenSizeMax = distInfo[0].screenSize.w.max
          if (screenSizeMin < screenSizeDataNow && screenSizeMax > screenSizeDataNow) {
            result.push(item)
          }
        }
      })
      if (result.length < 1) {
        this.$message.warning({
          message: this.$t('T_NO_RESULT'),
          duration: 3000
        })
      }
      this.MATCHINGMODELDATA(result)
      this.INSTALLMATCHINGMODELDATA(result)
      this.SET_THROWDISTANCE2SCREENSIZWIDTH(this.throwDistanceNow / tempWidth)
      // 设置condition值 输入/选择的单位、投影距离、屏幕尺寸、纵横比、房间的环境光、使用用途
      this.setCondition()
    },

    screenSizeDataChange () {
      if (this.dwhSelect === '0') {
        this.screenSizeDataNow = this.screenSizeData
      } else {
        let scData = this.$commonJs.changeUnit(this.screenSizeData, this.unitData.value, true)
        this.screenSizeData = this.$commonJs.changeUnit(scData, this.unitData.value, false)
        if (this.dwhSelect === '1') {
          this.screenSizeDataNow = this.$commonViewJs.getScreenSizeByCalX(scData, this.aspectRatioData).size
        } else {
          this.screenSizeDataNow = this.$commonViewJs.getScreenSizeByCalY(scData, this.aspectRatioData).size
        }
      }
    },

    changeDehSelect () {
      if (this.screenSizeDataNow !== '') {
        if (this.dwhSelect === '0') {
          this.screenSizeData = this.screenSizeDataNow
        } else {
          let sc = this.$commonViewJs.getScreenXYByScreenSize(this.screenSizeDataNow, this.aspectRatioData)
          if (this.dwhSelect === '1') {
            this.screenSizeData = this.$commonJs.changeUnit(sc.calX, this.unitData.value)
          } else {
            this.screenSizeData = this.$commonJs.changeUnit(sc.calY, this.unitData.value)
          }
        }
      }
    },

    comparenLesThrowratio (matchingLensID, lcdSize, target) {
      let result = false
      for (let i = 0; i < matchingLensID.length; i++) {
        if (result) {
          break
        }
        for (let j = 0; j < this.OptionLensSpec.length; j++) {
          if (this.OptionLensSpec[j].id === matchingLensID[i] && this.OptionLensSpec[j].lcdSize === lcdSize) {
            if (this.OptionLensSpec[j].throwRatio.indexOf('-') !== -1) {
              let temp = this.OptionLensSpec[j].throwRatio.split('-')
              if (temp.length < 2) {
                if (temp[0].trim() === target) {
                  result = true
                  break
                }
              } else {
                if (temp[0].trim() <= target && temp[1].trim() >= target) {
                  result = true
                  break
                }
              }
            } else if (Number(this.OptionLensSpec[j].throwRatio.trim()) === target) {
              result = true
              break
            }
          }
        }
      }
      return result
    },

    filterProjector (projector) {
      let result = true
      // Brightness color
      result = this.$commonJs.matchRange(projector.color, this.brightnessMax, this.brightnessMin)
      if (result) {
        // 获取对角线
        let screenSizeDiag = 0
        let aspectRatio = this.aspectRatioData.split(':')
        if (this.dwhSelect === '0') {
          screenSizeDiag = Math.pow(this.screenSizeData, 2) // inch
        } else if (this.dwhSelect === '1') {
          // 宽度求对角线
          // 单位 -> 厘米 -> 英尺
          let width = this.$commonJs.changeUnit(this.$commonJs.changeUnit(this.screenSizeData, this.unitData.value, true), 'T_INCH_DECIMAL')
          screenSizeDiag = (Math.pow(aspectRatio[0], 2) + Math.pow(aspectRatio[1], 2)) / Math.pow(aspectRatio[0], 2) * Math.pow(width, 2)
        } else {
          // 高度求对角线
          let height = this.$commonJs.changeUnit(this.$commonJs.changeUnit(this.screenSizeData, this.unitData.value, true), 'T_INCH_DECIMAL')
          screenSizeDiag = (Math.pow(aspectRatio[0], 2) + Math.pow(aspectRatio[1], 2)) / Math.pow(aspectRatio[1], 2) * Math.pow(height, 2)
        }
        if (this.ambientMin || this.ambientMax || this.ambientMin !== '' || this.ambientMax !== '') {
          let limit = 3
          if (this.appSelect !== '') {
            limit = this.applicationValue[this.appSelect].limit
          }
          let tempMin = screenSizeDiag * aspectRatio[0] * aspectRatio[1] * Math.pow(0.0254, 2) * this.ambientMin * (limit - 1) / (Math.pow(aspectRatio[0] * 1, 2) + Math.pow(aspectRatio[1], 2))
          let tempMax = screenSizeDiag * aspectRatio[0] * aspectRatio[1] * Math.pow(0.0254, 2) * this.ambientMax * (limit - 1) / (Math.pow(aspectRatio[0] * 1, 2) + Math.pow(aspectRatio[1], 2))
          result = this.$commonJs.matchRange(projector.color, tempMax, tempMin)
        } else if (this.appSelect !== '') {
          let temp = screenSizeDiag * aspectRatio[0] * aspectRatio[1] * Math.pow(0.0254, 2) * this.applicationValue[this.appSelect].bright * (this.applicationValue[this.appSelect].limit - 1) / (Math.pow(aspectRatio[0] * 1, 2) + Math.pow(aspectRatio[1], 2))
          if (projector.color * 1 !== temp) {
            result = false
          }
        }
      }
      return result
    },

    filterLensInfo (lensInfo) {
      let result = true
      let temp = lensInfo.throwRatio.split('-')
      // 判断throwRatio
      if ((this.throwRatioMin && temp[0].trim() * 1 < this.throwRatioMin * 1) || (this.throwRatioMax && temp[1].trim() * 1 > this.throwRatioMax * 1)) {
        result = false
      }
      // 判断lensshift
      if ((this.lesShiftData === '0' && lensInfo.lcd.lensShiftRange.v.max !== 0) || (this.lesShiftData === '1' && lensInfo.lcd.lensShiftRange.v.max === 0)) {
        result = false
      }
      return result
    },

    setCondition () {
      if (this.unitData) {
        this.SET_UNIT(this.unitData.value)
      }
      if (this.aspectRatioData || this.screenSizeData !== '') {
        this.ASPECTRATIO(this.aspectRatioData)
      }
      if (this.screenSizeData || this.screenSizeData !== '') {
        this.$nextTick(() => {
          EventBus.$emit('dwhSelect', this.dwhSelect)
          EventBus.$emit('changePjy', this.screenSizeData)
        })
      }
      if (this.appSelect) {
        this['SET_APPLICATION'](this.appSelect)
        this['SET_BRIGHTNESS'](this.applicationValue[this.appSelect].bright)
        this.$nextTick(() => {
          EventBus.$emit('appSelect', this.appSelect)
        })
      }
      if (this.ambientMax !== '') {
        this['SET_BRIGHTNESS'](this.ambientMax)
      }
    },

    testDigital (e, key) {
      e = e.replace(/[^0-9|.]/ig, '')
      let n = (this[key].split('.') || []).length - 1
      if (n > 1) {
        e = ''
      }
      this[key] = e
    },

    formatInput (key) {
      if (this[key] === '') {
        return
      } else if ((!this.isFraction || key.includes('brightness') || key.includes('ambient')) && isNaN(this[key])) {
        this[key] = '0'
      }
      if (!this.isFraction) {
        this[key] = (this[key] * 1).toFixed(3) * 1
      }
      if (key === 'throwDistance') {
        this.throwDistanceNow = this.$commonJs.changeUnit(this[key], this.unitData.value, true)
        this[key] = this.$commonJs.changeUnit(this.throwDistanceNow, this.unitData.value, false)
      }
      if (key === 'screenSizeData') {
        this.screenSizeDataChange()
      }
    },

    ...mapMutations([
      'MATCHINGMODELDATA',
      'INSTALLMATCHINGMODELDATA',
      'SET_UNIT',
      'SET_GRAPH_PJY',
      'ASPECTRATIO',
      'SET_APPLICATION',
      'SET_BRIGHTNESS',
      'SET_THROWDISTANCE2SCREENSIZWIDTH'
    ])
  }
}
</script>
<style scoped>
  .install-tip {
    padding-left: 20px;
    padding-top: 5px;
    display: block;
    color: #999999;
    border-right: 2px solid #bdbdbd;
  }
  .unit-select{
    max-width: 140px
  }
  .condition-select{
    width: 100px
  }
  .text-title{
    margin-right:10px;
    max-width: 100px;
    line-height: 12px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    top: 2px;
  }

</style>



// WEBPACK FOOTER //
// src/view/searchTabs/installCondition.vue